<div class="promo-line">
  <div class="layout-container" (click)="openPricing.emit()">
    <app-icon [icon]="promoIcon"></app-icon>
    <div class="title" *mediaIf="'large'">{{ promo?.line?.line_title }}</div>
    <div class="description" *mediaIf="'large'; else smDescription">
      {{ promo?.line?.line_description }}
    </div>
    <ng-template #smDescription>
      {{ promo?.line?.line_mobile_title || promo?.line?.line_description }}
    </ng-template>
    <button class="promo-btn" [class.animated]="showCopyCheck"
      (click)="copyCode.emit(); $event.stopImmediatePropagation()"
       *mediaIf="'large'">
      {{ promo?.code }}
      <div class="promo-btn-icon" *mediaIf="'large'">
          <app-icon [icon]="copyIcon"></app-icon>
          <app-icon [icon]="checkIcon" style="opacity: 0;"></app-icon>
      </div>
    </button>
    <app-icon [icon]="closeIcon" (click)="closePromo.emit(); $event.stopImmediatePropagation()" *mediaIf="'large'"></app-icon>
  </div>
</div>
